import "./GlobalLoader.css";

export default function GlobalLoader() {
  return (
    <div
      style={{
        width: "100%",
        height: "80%",
        display: "grid",
        gridTemplate: "1fr 1fr",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="zoom-in-out-element">
        My<span style={{ color: "red" }}>Care</span>Flex
      </div>
    </div>
  );
}
